export const QUESTIONNAIRE_SUBMIT_ERROR_FALLBACK = 'No pudimos enviar tu cuestionario. Intenta nuevamente más tarde.';

/**
 */
export function resolveQuestionnaireSubmitErrorMessage(literals) {
  return literals?.questionnaire?.submitError
    || QUESTIONNAIRE_SUBMIT_ERROR_FALLBACK;
}
